import React, { useRef } from 'react'
import { useSelector } from 'react-redux'
import clsx from 'clsx'


import { AppState } from '../../../../store'
import { Environment } from '../../../../environment/app-settings'
import { LoanCalculatorLoanPredefinedPeriodButtonProps, LoanCalculatorManualChooseInstalmentProps, LoanCalculatorSlidersTypes } from '../LoanOfferSummaryPanelEditableProps'
import AppButton from '../../../atoms/AppButton/AppButton'
import { UI_BUTTON_TYPE } from '../../../atoms/AppButton/AppButtonProps'
import { numberToDisplayString } from '../../../../common/helpers/number.helpers'
import PageHeader from '../../../atoms/PageHeader/PageHeader'
import { HEADER_LEVEL } from '../../../atoms/PageHeader/PageHeaderProps'
import { APP_COLOR } from '../../../atoms/AtomsGlobalProps'
import Paragraph from '../../../atoms/Paragraph/Paragraph'
import { PREDEFINED_PERIODS_OFFER_LOGIC } from '../../../../store/types'
import { monthsAmountDisplayedNames, sleep } from '../../../../common/helpers/helpers'


import '../LoanOfferSummaryPanelEditableStyles.scss'
import './LoanCalculatorManualChooseInstalmentStyles.scss'


const LoanCalculatorLoanPredefinedPeriodButton = (props: LoanCalculatorLoanPredefinedPeriodButtonProps) => {
   const { isCurrentSelected, instalment, handleOnLoanInstalmentButtonClick } = props

   return (
      <AppButton 
         onClick={handleOnLoanInstalmentButtonClick} 
         uiButtonType={UI_BUTTON_TYPE.PRIMARY} 
         className={clsx('manual-choose-instalment-button--main', isCurrentSelected? 'manual-choose-instalment-button--selected' : 'manual-choose-instalment-button--default')}
      >
        { monthsAmountDisplayedNames(instalment) }
      </AppButton>
   )
}

/**
 * [ZAŁOŻENIE BIZNESOWE] - MECHANIZM PREDEFINIOWANYCH OKRESÓW POŻYCZKI
 * Komponent pokazujący predefiniowane przyciski do zmiany okresu pożyczki w kalkulatorze pożyczki
 * @returns 
 */
const LoanCalculatorManualChooseInstalment = (props: LoanCalculatorManualChooseInstalmentProps) => {
   const { currentSelectedPredefinedPeriod } = useSelector((state: AppState) => state.applicationState)
   const { instalmentAmount, handleOnPredefinedPeriodButtonClick } = props
 
   return (
      <div className='loan-calculator-editable-manual-choose-outer-wrapper'>
         <PageHeader 
            title={"Na okres"} level={HEADER_LEVEL.H4} aria-live="polite" color={APP_COLOR.PRIMARY} align='center' 
            className='loan-calculator-editable-manual-choose-instalment-header'
         />
         <div className='loan-calculator-editable-manual-choose-instalment-outer-wrapper'>
            <LoanCalculatorLoanPredefinedPeriodButton 
               instalment={Environment.PREDEFINED_PERIODS_OFFER_LOGIC_INSTALMENT_MAP[PREDEFINED_PERIODS_OFFER_LOGIC.SHORT_PERIOD]} 
               isCurrentSelected={currentSelectedPredefinedPeriod === PREDEFINED_PERIODS_OFFER_LOGIC.SHORT_PERIOD}
               handleOnLoanInstalmentButtonClick={async() => await handleOnPredefinedPeriodButtonClick(PREDEFINED_PERIODS_OFFER_LOGIC.SHORT_PERIOD)}
            />
            <LoanCalculatorLoanPredefinedPeriodButton 
               instalment={Environment.PREDEFINED_PERIODS_OFFER_LOGIC_INSTALMENT_MAP[PREDEFINED_PERIODS_OFFER_LOGIC.LONG_PERIOD]} 
               isCurrentSelected={currentSelectedPredefinedPeriod === PREDEFINED_PERIODS_OFFER_LOGIC.LONG_PERIOD}
               handleOnLoanInstalmentButtonClick={async() => await handleOnPredefinedPeriodButtonClick(PREDEFINED_PERIODS_OFFER_LOGIC.LONG_PERIOD)}
            />
         </div>
         <div>
            <Paragraph bold aria-live="polite" color={APP_COLOR.PRIMARY} align='center' className='loan-calculator-editable-manual-choose-instalment-heading--instalment-amount'>
               Rata: <span>{numberToDisplayString(instalmentAmount, " zł")}</span>
            </Paragraph>
         </div>
      </div>
   )
}

export default LoanCalculatorManualChooseInstalment